import {svgIconWrapper} from '../svg-icon-wrapper';

import FilterListRegular from './filter-list-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <FilterListRegular {...validProps} />;
}

SvgComponent.iconName = 'filterListRegular';

export const FilterListRegularIcon = svgIconWrapper(SvgComponent);
